<template lang="pug">
  .average-result.clearfix.xs-f-small.md-f-medium.max-at-tweak.text-center(v-if="fieldSummary")
    .xs-12
      p.xs-f-small.md-f-medium.max-at-tweak {{title}}

    .bars.xs-12.flex-box
      .bar.flex-1(v-for="(field, index) in orderedFields" :key="field + '-' + index" :class="{'summary-average': index == summaryAverageIndex}")

    .bottom-text.xs-12
      .xs-6.text-left
        p.inline-block.text-left.text-color-2.xs-f-xsmall.lg-f-small.max-at-tweak {{leftText}}

      .xs-6.text-right
        p.inline-block.text-right.text-color-2.xs-f-xsmall.lg-f-small.max-at-tweak {{rightText}}

</template>

<script>
  export default {
    name: "AverageResult",

    props: {
      title: {
        type: String
      },

      leftText: {
        type: String
      },

      rightText: {
        type: String
      },

      fieldSummary: {
        type: Object
      },

      fieldSummaryOrder: {
        type: Array
      }
    },

    computed: {
      orderedFields() {
        var ordered = [];

        this.fieldSummaryOrder.forEach(fieldKey => {
          if (this.fieldSummary[fieldKey]) {
            ordered.push({
              fieldKey: fieldKey,
              amount: this.fieldSummary[fieldKey]
            });
          }
        });

        return ordered;
      },

      summaryAverageIndex() {
        var answerTotal = 0;
        var summaryTotal = 0;

        this.orderedFields.forEach((orderedField, index) => {
          answerTotal += orderedField.amount;
          summaryTotal += (index + 1) * orderedField.amount;
        });

        return Math.ceil(summaryTotal / answerTotal) - 1;
      }
    }
  }
</script>

<style scoped lang="stylus">
  .average-result
    padding 0.5em 8% 1em

    .bars
      .bar
        height 0.5em
        background-color color-fog-light
        margin 0.5em 0.25em
        margin-top 1em

        &:first-child
          margin-left 0

        &:last-child
          margin-right 0

        &.summary-average
          background-color brand-color-2

    @media mq-desktop-md-plus
      padding 0.5em 6% 1em

</style>
